module.exports = __webpack_public_path__ + "static/media/admin-logo.4b4c6c5b.svg";